import {
  GET_HOLIDAY,
  GET_HOLIDAY_SUCCESS,
  GET_HOLIDAY_FAILURE,
  DELETE_HOLIDAY,
  DELETE_HOLIDAY_SUCCESS,
  DELETE_HOLIDAY_FAILURE,
  EDIT_HOLIDAY,
  EDIT_HOLIDAY_SUCCESS,
  EDIT_HOLIDAY_FAILURE,
  ADD_HOLIDAY,
  ADD_HOLIDAY_SUCCESS,
  ADD_HOLIDAY_FAILURE,
} from "../Constants";

export const GetHoliday = (payload) => ({
  type: GET_HOLIDAY,
  payload,
});

export const GetHolidaySuccess = (payload) => ({
  type: GET_HOLIDAY_SUCCESS,
  payload,
});

export const GetHolidayFailure = (payload) => ({
  type: GET_HOLIDAY_FAILURE,
  payload,
});

export const DeleteHoliday = (payload) => ({
  type: DELETE_HOLIDAY,
  payload,
});

export const DeleteHolidaySuccess = (payload) => ({
  type: DELETE_HOLIDAY_SUCCESS,
  payload,
});

export const DeleteHolidayFailure = (payload) => ({
  type: DELETE_HOLIDAY_FAILURE,
  payload,
});

export const EditHoliday = (payload) => ({
  type: EDIT_HOLIDAY,
  payload,
});

export const EditHolidaySuccess = (payload) => ({
  type: EDIT_HOLIDAY_SUCCESS,
  payload,
});

export const EditHolidayFailure = (payload) => ({
  type: EDIT_HOLIDAY_FAILURE,
  payload,
});

export const AddHoliday = (payload) => ({
  type: ADD_HOLIDAY,
  payload,
});

export const AddHolidaySuccess = (payload) => ({
  type: ADD_HOLIDAY_SUCCESS,
  payload,
});

export const AddHolidayFailure = (payload) => ({
  type: ADD_HOLIDAY_FAILURE,
  payload,
});
